import HubspotPagesDashboard from "./HubspotPagesDashboard";

export default HubspotPagesDashboard;
